import React, {useState} from 'react'
import styled from 'styled-components'
import { message, Button } from 'antd';
import { useTranslation } from 'contexts/Localization'
import BackOrNext from "../../../components/BackOrNext"
import TourDialog from  '../../../components/TourDialog'

interface Props {
    setLable: (event) => void
}
const Portal: React.FC<Props> = ({setLable}) => {
    const { t } = useTranslation();
    const textChildren = (<>
        <span>
                        {t("Please remain quiet and respectful in this sacred grove. We’re now approaching the Portal, where Heroes are summoned into the Kingdom.")}
                    </span>
        <span>
                        {t("In order to summon a Hero, the ")}
            <b>{t("Archdruid Agranam")}</b>
            {t(" performs a ritual along with two Heroes, infusing a crystal with energy channeled from the Heroes. After this ritual, ")}
            <b>{t("the Summoner, Lisa")}</b>
            {t(", places the crystal in the portal. The crystal is consumed, and a new Hero enters the realm!")}
                    </span>
        <span>
                        {t("This new Hero will inherit some of the attributes of the Heroes who gave their energy to infuse the summoning crystal. No two Heroes will be exactly alike, and a key part of being successful in Song Of Rising is successfully summoning powerful Heroes. The considerations around summoning are many and varied.")}
                    </span>
    </>)
    const btnChildren = (
        <BackOrNext setLable={setLable} backLable="professions" activeIndex={1} count={1} nextLable="joining" isNextMap nextTitle="To Joining"/>
    )
    return <TourDialog setLable={setLable} title={t("The Church")} imgUrl='images/npc/go-G.png' btnChildren={btnChildren} textChildren={textChildren}/>
    }

const StyledPortal = styled.div`
  width: 100%;
  padding: 30px;
  background-color: ${({theme})=> theme.expandColor.color.primary};
  display: flex;
  flex-direction: column;
  ${({theme}) => theme.mediaQueries.sm} {
    width: 700px;
    height: 470px;
  }
  & .title {
    text-align: center;
    font-size: 30px;
    color: ${({theme})=> theme.expandColor.color.active};
    padding: 10px;
  }
`

const StyledPortalRow = styled.div`
  display: flex;
  flex-direction: column;
  ${({theme}) => theme.mediaQueries.sm} {
    flex-direction: row;
  }
`
const StyledPortalLeft = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  ${({theme}) => theme.mediaQueries.sm} {
    width: 200px;
  }
  & img {
    object-fit: cover;
    height: 180px;
  }
`

const StyledPortalRight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({theme}) => theme.mediaQueries.sm} {
    width: 440px;
  }
  & span {
    font-size: 16px;
    padding: 10px 0;
  }
`

const StyledPortalBotton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  flex-direction: column;
  ${({theme}) => theme.mediaQueries.sm} {
    flex-direction: row;
  }
`
const StyledPortalBack = styled.div`
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  text-align: end;
  margin-right: 0;
  padding-right: 10px;
  background-color: ${({theme})=> theme.expandColor.color.active};
  cursor: pointer;
  ${({theme}) => theme.mediaQueries.sm} {
    margin-right: 10px;
  }
  & span {
    padding:0 1px 0 0;
  }
  &:hover {
    & span {
      padding: 0 0 0 10px;
      transition: all 0.5s;
    }
  }
`
const StyledPortalNext = styled.div`
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  margin-left: 0;
  padding-left: 10px;
  margin-top: 20px;
  background-color: ${({theme})=> theme.expandColor.color.active};
  cursor: pointer;
  ${({theme}) => theme.mediaQueries.sm} {
    margin-left: 10px;
  }
  & span {
    padding:0 1px 0 0;
  }
  &:hover {
    & span {
      padding: 0 10px 0 0;
      transition: all 0.5s;
    }
  }
`
export default Portal
